import { defineNuxtPlugin } from 'nuxt/app';
import type { Pinia } from 'pinia';
import { createPersistedState } from 'pinia-plugin-persistedstate';

export default defineNuxtPlugin((nuxtApp) => {
    if (import.meta.client) {
        const pinia = nuxtApp.$pinia as Pinia;
        pinia.use(createPersistedState()); // Enable Pinia Persisted State Plugin
    }
});